<template>
    <form class="row q-col-gutter-md">
        <div class="col-12 text-center" v-show="CurrentPhoto">
            <q-img
                :src="CurrentPhoto"
                :ratio="1"
                style="width: 200px;"
            />
        </div> <!-- image -->
        <div class="col-12" v-show="!CurrentPhoto">
            <file-collector
                v-model="UserObj.image"
                multiple
                class="col-12"
                label="User's image"
                name="image"
                attach-file-label="Select an image"
                ref="collector"
                file-types="image/*"
                :max-file-size="25 * 1024 * 1024"
                :max-total-size="40 * 1024 * 1024"
                :error="UserObj.errors.get('image', true)"
                :of="$t('of')"
            />
        </div>
    </form>
</template>
<script>
import FileCollector from "src/components/FileCollector.vue"
export default {
    name: "IdDocumentForm",
    model: {
        prop: 'UserObj',
        event: 'change'
    },
    props: {
        UserObj: {
            type: Object,
            default: false
        },
        CurrentPhoto: {
            type: String,
            default: ''
        }
    },
    computed: {
        image() {
            return this.UserObj.image
        }
    },
    data() {
        return {

        }
    },
    methods: {
        copied(message) {
            this.$q.notify({
                message: message,
                position: 'top'
            })
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
        image(val) {
            if (!val) {
                this.$refs.collector.reset()
            }
        }
    },
    components: {FileCollector},
}
</script>
<style>

</style>
